import { useEffect, useState } from "react";

export default function Countdown({ targetDate, label = "DO NAJBLIŻSZEGO ZLOTU" }) {
  const [tl, setTl] = useState(calc(targetDate));

  useEffect(() => {
    const id = setInterval(() => setTl(calc(targetDate)), 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  if (!tl) return null;

  const Box = ({ value, unit }) => (
    <div className="sr-card px-4 py-4 md:px-6 md:py-5 text-center min-w-[78px] md:min-w-[110px]" data-testid={`cd-${unit}`}>
      <div className="font-display text-3xl md:text-5xl text-[var(--sr-fire)]">{String(value).padStart(2, "0")}</div>
      <div className="font-nav text-[10px] md:text-xs uppercase tracking-widest mt-1" style={{ color: "var(--sr-cream-soft)" }}>{unit}</div>
    </div>
  );

  return (
    <div className="text-center" data-testid="countdown">
      <p className="font-nav text-xs md:text-sm tracking-[0.3em]" style={{ color: "var(--sr-cream-soft)" }}>{label}</p>
      <div className="flex justify-center gap-3 md:gap-5 mt-5">
        <Box value={tl.days} unit="DNI" />
        <Box value={tl.hours} unit="GODZIN" />
        <Box value={tl.mins} unit="MINUT" />
        <Box value={tl.secs} unit="SEKUND" />
      </div>
    </div>
  );
}

function calc(target) {
  const diff = new Date(target).getTime() - Date.now();
  if (isNaN(diff) || diff <= 0) return null;
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff / 3600000) % 24);
  const mins = Math.floor((diff / 60000) % 60);
  const secs = Math.floor((diff / 1000) % 60);
  return { days, hours, mins, secs };
}
